// extracted by mini-css-extract-plugin
export default {"dont-oversize":"Attachment_dont-oversize__8TEe0","size-sm":"Attachment_size-sm__vDsMs","loading-icon-sm":"Attachment_loading-icon-sm__Ze8W4"};